const ERROR_ENUM = {
  ListingAgreement: {
    code: '401',
    details: 'restricted_to_brokers'
  },
  ListingExpired: {
    code: '404',
    details: 'listing_expired'
  },
  Unauthorized: {
    code: '403',
    details: 'unathorized'
  },
  Unknown: {
    code: '400',
    details: 'unknown_error'
  }
};

export {ERROR_ENUM};
